export const ChonkyDndFileEntryType = "dnd-chonky-file-entry";
